let inMemoryToken = null;

export const setToken = (token) => {
  inMemoryToken = token;
};

export const getToken = () => {
  if (inMemoryToken) return inMemoryToken;

  if (typeof window !== "undefined") {
    // Si hay un token de paciente guardado en sessionStorage, usarlo
    const patientToken = sessionStorage.getItem("patient_token");
    if (patientToken) {
      inMemoryToken = patientToken;
      return patientToken;
    }
    const accessToken = sessionStorage.getItem("access_token");
    if (accessToken) {
      inMemoryToken = accessToken;
      return accessToken;
    }
  }

  return null;
};

export const clearToken = () => {
  inMemoryToken = null;
};
